export const setFavicon = () => {
  const favicon: any = document.querySelector('link[rel="icon"]');
  if (!favicon) {
    return;
  }

  const basePath = `${window.location.origin}/`;
  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const faviconFile = isDarkMode ? 'optilift-logo-dark.svg' : 'optilift-logo-light.svg';
  favicon.href = new URL(faviconFile, basePath).toString();
};
